import { SelectMultipleProps } from "@yuno/design-system-web"
import { AlternativeTextTypoSelect } from "../components/filters/styles"
import { useTranslation } from 'react-i18next'

export const selectRender = (selected: SelectMultipleProps['value'], options: string[]) => {
  const { t } = useTranslation()
    if (selected.length === 0) {
      return <AlternativeTextTypoSelect>{t('select')}</AlternativeTextTypoSelect>
    }
    if (selected.length === options.length) {
      return <AlternativeTextTypoSelect>{t('all')}</AlternativeTextTypoSelect>
    }
    return `${selected.length} ${t('selected')}`
  }